var _require = require("../data"),
    units = _require.units;

var checkNumber = function checkNumber(value) {
  if (isNaN(+value)) {
    throw new TypeError("Expect a Number");
  }

  return true;
};

var checkZero = function checkZero(value) {
  return value === 0 ? "0" : false;
};

var withUnit = function withUnit(suffix) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return checkNumber(value) && (checkZero(value) || "".concat(value).concat(suffix));
  };
};

units.forEach(function (unit) {
  var name = unit;

  switch (unit) {
    case "in":
      name = "inch";
      break;
  }

  exports[name] = withUnit(unit);
});

exports.percent = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var withDecimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return withUnit("%")(value * (withDecimal ? 100 : 1));
};